//React
import { useState, useEffect } from "react";
//Material UI
import Modal from '@mui/material/Modal';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircularProgress from "../CircleProgress";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
//CSS
import "./ChangePasswordModal.css";
import SecureStorage from 'react-secure-storage';
import { LoginApi } from "../../api";

export default function ChangePasswordModal(props) {
  const [step, setStep] = useState(0);
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [displayNewPassword, setDisplayNewPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [confirmNewPasswordShown, setConfirmNewPasswordShown] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [passwordInfo, setPasswordInfo] = useState({
    lowercase: false,
    special: false,
    length: false,
  });

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };
  const toggleNewPasswordVisibility = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleConfirmNewPasswordVisibility = () => {
    setConfirmNewPasswordShown(!confirmNewPasswordShown);
  };

  // step 변경에 따라 UI 업데이트
  useEffect(() => {
    switch (step) {
      case 1:
        handleCheckPassword();
        break;
      case 2:
        handleChangePassword();
        break;
      default:
        if (step >= 2) {
          setStep(2);
        }
        break;
    }
  }, [step]);

  useEffect(() => {
    if (newPassword) {
      const lowercase = /[a-z]/.test(newPassword);
      const special = /[!@#$%^&*]/.test(newPassword);
      const length = newPassword.length >= 8;

      setPasswordInfo({
        lowercase,
        special,
        length,
      });
    } else {
      setPasswordInfo({
        lowercase: false,
        special: false,
        length: false,
      });
    }
  }, [newPassword]);

  // 전체 비밀번호 검증 통과 여부 확인
  const checkPassword = () => {
    return passwordInfo.lowercase && passwordInfo.special && passwordInfo.length;
  };

  const handleCheckPassword = async () => {
    try {
      const response = await LoginApi.checkPassword({
        email: SecureStorage.getItem('email'),
        password: password,
      });
      if (response.data === true) {
        setDisplayNewPassword(true);
      } else {
        setStep(0);
        alert("비밀번호 확인에 실패했습니다.");
      }
    }
    catch (error) {
      console.error("checkPassword Error ->", error);
    }
  }

  const handleChangePassword = async () => {
    try {
      const response = await LoginApi.changePassword({
        email: SecureStorage.getItem('email'),
        password: newPassword,
      });
      console.log("response ->", response.data.tokenInfo);
      if (response.statusCode === 200) {
        SecureStorage.setItem("uid", response.data.uid);
        SecureStorage.setItem("accessToken", response.data.tokenInfo.accessToken);
        SecureStorage.setItem("refreshToken", response.data.tokenInfo.refreshToken);
        props.handleClose();
        alert("비밀번호 변경이 완료되었습니다.");
      } else {
        setStep(0);
        alert("비밀번호 변경에 실패했습니다.");
      }
    }
    catch (error) {
      console.error("changePassword Error ->", error);
    }
  }
  // 비밀번호 일치 여부 확인
  useEffect(() => {
    if (confirmNewPassword) {
      const match = newPassword === confirmNewPassword;
      setPasswordMatch(match);
    } else {
      setPasswordMatch(false);
    }
  }, [newPassword, confirmNewPassword]);

  // 모달이 닫힐 때 모든 상태 초기화
  useEffect(() => {
    if (!props.open) {
      setStep(0);
      setDisplayNewPassword(false);
      setPassword("");
      setPasswordShown(false);
      setNewPassword("");
      setNewPasswordShown(false);
      setConfirmNewPassword("");
      setConfirmNewPasswordShown(false);
      setPasswordMatch(false);
      setPasswordInfo({
        lowercase: false,
        special: false,
        length: false,
      });
    }
  }, [props.open]);

  return (
    <div>
      <button onClick={props.handleOpen}>Open modal</button>
      <Modal
        open={props.open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            props.handleClose();
          }
        }}
        disableAutoFocus
      >
        <div className="change-password-modal-container">
          <div>
            {displayNewPassword ? <div className="change-password-modal-title">
              새로운 비밀번호를 입력해주세요.
            </div> : <div className="change-password-modal-title">
              현재 패스워드를 입력해주세요.
            </div>}
            {displayNewPassword ? <div>
              비밀번호는 소문자, 특수기호를 포함해야되며<br />최소 8자리 이상이어야 합니다.
            </div> : null}
          </div>
          <div>
            {!displayNewPassword && <div className="change-password-modal-form-group">
              <div className="change-password-modal-wrapper">
                <input
                  className="change-password-modal-input"
                  type={passwordShown ? "text" : "password"}
                  placeholder="비밀번호를 입력해주세요."
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={props.loading}
                />
                <button
                  className="change-password-modal-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {passwordShown ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
            </div>}
            {displayNewPassword && <div>
              <div className="change-password-modal-password-info">
                <div style={{ color: !passwordInfo.lowercase ? "var(--color-danger)" : "var(--color-bg-dark)" }}>
                  {!passwordInfo.lowercase ? (
                    <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }} />
                  ) : (
                    <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />
                  )}
                  소문자 포함
                </div>
                <div style={{ color: !passwordInfo.special ? "var(--color-danger)" : "var(--color-bg-dark)" }}>
                  {!passwordInfo.special ? (
                    <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }} />
                  ) : (
                    <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />
                  )}
                  특수기호 포함
                </div>
                <div style={{ color: !passwordInfo.length ? "var(--color-danger)" : "var(--color-bg-dark)" }}>
                  {!passwordInfo.length ? (
                    <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }} />
                  ) : (
                    <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />
                  )}
                  8자리 이상
                </div>
              </div>
              <div className="change-password-modal-form-group">
                <div className="change-password-modal-label">새로운 비밀번호</div>
                <div className="change-password-modal-wrapper">
                  <input
                    className="change-password-modal-input"
                    type={newPasswordShown ? "text" : "password"}
                    placeholder="새로운 비밀번호를 입력해주세요."
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    disabled={props.loading}
                  />
                  <button
                    className="change-password-modal-toggle"
                    onClick={toggleNewPasswordVisibility}
                  >
                    {newPasswordShown ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </button>
                </div>
              </div>
              <div className="change-password-modal-gap"></div>
              <div className="change-password-modal-form-group" style={{ marginBottom: "30px" }}>
                <div className="change-password-modal-label">새로운 비밀번호 확인</div>
                <div className="change-password-modal-wrapper">
                  <input
                    className="change-password-modal-input"
                    type={confirmNewPasswordShown ? "text" : "password"}
                    placeholder="새로운 비밀번호를 입력해주세요."
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    disabled={props.loading}
                    style={{
                      border: confirmNewPassword.length > 0
                        ? (passwordMatch ? "1px solid #cecece" : "1px solid var(--color-danger)")
                        : undefined
                    }}
                  />
                  <button
                    className="change-password-modal-toggle"
                    onClick={toggleConfirmNewPasswordVisibility}
                  >
                    {confirmNewPasswordShown ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </button>
                </div>
              </div>
            </div>}
          </div>
          <div className="change-password-modal-button-container">
            <button
              className="change-password-modal-cancel-button"
              onClick={props.handleClose}
            >
              취소
            </button>
            <button
              className={`change-password-modal-next-button ${
                props.loading ||
                !password ||
                (step === 1 &&
                  (!passwordInfo.lowercase ||
                    !passwordInfo.special ||
                    !passwordInfo.length ||
                    !passwordMatch))
                  ? "loading"
                  : ""
              }`}
              onClick={() => setStep(prev => prev + 1)}
              disabled={
                props.loading ||
                !password ||
                (step === 1 &&
                  (!passwordInfo.lowercase ||
                    !passwordInfo.special ||
                    !passwordInfo.length ||
                    !passwordMatch))
              }
            >
              확인
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}